'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GREEN = exports.GREEN = 'green-theme';
var BLUE = exports.BLUE = 'blue-theme';
var ORANGE = exports.ORANGE = 'orange-theme';
var RED = exports.RED = 'red-theme';
var NAVY = exports.NAVY = 'navy-theme';
var DARK_GREEN = exports.DARK_GREEN = 'dark-green-theme';
var DARK_THEME = exports.DARK_THEME = 'dark-theme';


//////////////////
// WEBPACK FOOTER
// ./src/containers/Order/constants.js
// module id = 1822
// module chunks = 0